import * as React from 'react';

import { Banner, type IBannerProps } from '../Banner';

import * as styles from './styles.css';

type TDesktopBannerProps = Omit<IBannerProps, 'rootClassName'>;

export const DesktopBanner: React.FC<TDesktopBannerProps> = props => {
  return <Banner {...props} rootClassName={styles['desktop-banner']} />;
};

DesktopBanner.displayName = 'DesktopBanner';
